import React, { useContext, useEffect, useRef, useState } from "react";
import "./style.css";
import { Breadcrumb } from "../../Components/Atoms";
import PATHS from "../../Routes/paths";
import { ClientPicker } from "../../Components/Molecules";
import { Autocomplete, Circle, DrawingManager, GoogleMap, InfoWindow, Marker, Polygon, useJsApiLoader } from "@react-google-maps/api";
import { GeoFenceIcon, PolygonIcon, SearchIcon } from "../../Assets/images/svgs";
import { Button, Checkbox, Input, useToast } from "@chakra-ui/react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { addNewGeofence, getGeofencesByClient, updateGeofence, saveAlert, updateAlert, getAlerts } from "../../APIs";
import { StoreContext } from "../../Library/contexts";
import { GEOFENCE_TRIGGER_TYPE, GOOGLE_MAPS_API_KEY, GOOGLE_MAPS_VERSION } from "../../Library/constants";
import { ALERT_VEHICLE_TABLE_HEADERS } from "../../Library/tableHeaders";
import { isEqual } from "lodash";
import { AlertsVehiclesTable } from "../../Components/Organisms";

const AddGeofence = ({ fromOverspeedPage, emitAlertData, setEmitAlertData }) => {
  const libraries = [ "places", "drawing", "geometry" ];
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries,
    version: GOOGLE_MAPS_VERSION,
  });
  const [fromAlerts, setFromAlerts] = useState(true)

  const { filters, userVehicles, allGeofences, setAllGeofences } = useContext(StoreContext);

  const Toast = useToast();
  const [ searchParams ] = useSearchParams();
  const geofenceId = useRef(searchParams.get("idx"));
  const editIdx = +searchParams.get("editIdx");
  if (Boolean(searchParams.get("edit"))) geofenceId.current = editIdx;

  const navigate = useNavigate();

  const isEdit = useRef(false);

  const mapRef = useRef();
  const circleRef = useRef();
  const polygonRef = useRef();
  const editedPolygonVertices = useRef();
  const setMapCircleRef = useRef();
  const autocompleteRef = useRef();
  const gfNameRef = useRef("");
  const gfAreaRef = useRef("");
  const fencesFetchedOnce = useRef(false);
  const drawingManagerRef = useRef(null);
  const isClearingRef = useRef(null);

  const editedGeofenceRef = useRef();

  const breadcrumbPaths = [
    { idx: 1, name: "Lease", link: PATHS.LEASE },
    { idx: 2, name: "Vehicles", link: PATHS.LEASED_VEHICLES },
    { idx: 2, name: "Add Geofence", isCurrentPage: true },
  ];

  const fromAlertBreadcrumbPaths = [
    {
      idx: 1,
      name: "Geofence Alerts",
      link: `${PATHS.SET_ALERTS}?tab=${1}`,
    },
    { idx: 2, name: isEdit.current ? "Edit Geofence" : "Add Geofence", isCurrentPage: true },
  ];

  const [ mapCenter, setMapCenter ] = useState({ lat: 20.5937, lng: 78.9629 }) //default india
  const [ markerLoc, setMarkerLoc ] = useState({ })
  const [ isDrawing, setIsDrawing ] = useState(false);
  const [ circle, setCircle ] = useState(null);
  const [ polygon, setPolygon ] = useState(null);
  const [ geofenceName, setGeofenceName ] = useState("");
  const [ geofenceArea, setGeofenceArea ] = useState("");
  const [ enableSaveGeofence, setEnableSaveGeoFence ] = useState(false);
  const [ triggerRender, setTriggerRender ] = useState(false);
  const [ infoWindowDetails, setInfoWindowDetails ] = useState({});
  const [ showExistingGeofences, setShowExistingGeofences ] = useState(false);
  const [ selectedDrawMode, setSelectedDrawMode ] = useState(null);
  const [ updatedPolygon, setUpdatedPolygon ] = useState("");
  const [ errorMsg, setErrorMsg ] = useState("");
  const geofenceVids = useRef({});

  const [ geofenceToEdit, setGeofenceToEdit ] = useState({});
  const SelectedVids = useRef([]);
  const location = useLocation();

  const onLoad = (map) => {
    mapRef.current = map;

    if (geofenceId.current) {
      isEdit.current = true;
      if (fromAlerts) {
        getGeofenceAlertToEdit(location.state, geofenceId.current);
      }
      else {
        getGeofenceToEdit(filters.client, geofenceId.current);
      }
    }
  };

  const fitBoundsForPolygon = (coordinates) => {
    if (!coordinates || coordinates.length === 0) return;
    coordinates = normalizeCoordinates(coordinates);

    const bounds = new window.google.maps.LatLngBounds();

    coordinates.forEach(({ lat, lng }) => {
      bounds.extend(new window.google.maps.LatLng(lat, lng));
    });

    mapRef.current.fitBounds(bounds);
  };


  const fitBounds = (data) => {
    if (data.vertices) return fitBoundsForPolygon(data.vertices);

    let bounds = new window.google.maps.LatLngBounds();
      const degreesPerMeter = 0.000009;
      const radialDistance = data.r * degreesPerMeter;
      const circleBounds = {
        north: data.clat + radialDistance,
        south: data.clat - radialDistance,
        east: data.clong + radialDistance,
        west: data.clong - radialDistance,
      };

      bounds.extend(new window.google.maps.LatLng(circleBounds.north, circleBounds.east));
      bounds.extend(new window.google.maps.LatLng(circleBounds.south, circleBounds.west));
      mapRef.current.fitBounds(bounds);
  }

  const getGeofenceAlertToEdit = (data, geofenceIdx) => {
    let newData = null;
    if (geofenceIdx) newData = allGeofences.find(gf => gf.idx === +geofenceIdx);
    if (newData) data = newData;

    if(data){
      if (data.vertices && data.vertices.length) data.vertexes = normalizeCoordinates(data.vertices);
      setGeofenceToEdit(data);
      setGeofenceName(data.title);
      setGeofenceArea(data.region);
      gfNameRef.current = data.title;
      gfAreaRef.current = data.region;
      if (data.vertices) {
        let polygonCenter = getPolygonCenter(data.vertices, true);
        setMapCenter({ lat: polygonCenter.lat, lng: polygonCenter.lng });
      } else {
        setMapCircleRef.current = { center: { lat: () => data.clat, lng: () => data.clong }, radius: data.r };
        setMapCenter({ lat: data.clat, lng: data.clong });
      }
      SelectedVids.current = data.vehIdArr;
      geofenceVids.current = data.vehIdArr;
      setTriggerRender((prev) => !prev);
      fitBounds(data);
    }
  }

  const getGeofenceToEdit = async (client, geofence) => {
    try {
      let data = await getGeofencesByClient(client, geofence);
      setGeofenceToEdit(data);
      setGeofenceName(data.title);
      setGeofenceArea(data.region);
      gfNameRef.current = data.title;
      gfAreaRef.current = data.region;
      setMapCenter({ lat: data.clat, lng: data.clong });

      fitBounds(data);
    } catch(error) {
      console.error(error);
      Toast({ isClosable: true, description: error || "Something went wrong", position: "bottom", variant: "subtle", duration: 3000 });
    }
  }


  const fetchCurrentLocation = (lat, long) => {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: { lat: lat, lng: long } }, (res, status) => {
      if (status === "OK") {
        if (res && res.length) {
          let area = res[0].formatted_address;
          area = area.split(",")?.slice(0, -2)?.join();
          setGeofenceArea(area);
          gfAreaRef.current = area;
        }
      }
    })
  }

  const onCircleComplete = (circle) => {
    setMapCircleRef.current = circle;
    window.google.maps.event.addListener(circle,'radius_changed', function () {
      setCircle({ r: circle.radius, clat: circle.center.lat(), clong: circle.center.lng() });
    })

    window.google.maps.event.addListener(circle,'center_changed', function () {
      fetchCurrentLocation(circle.center.lat(), circle.center.lng());
      setCircle({ r: circle.radius, clat: circle.center.lat(), clong: circle.center.lng() });
    })

    fetchCurrentLocation(circle.center.lat(), circle.center.lng());
    setCircle({ r: circle.radius, clat: circle.center.lat(), clong: circle.center.lng() });
    setIsDrawing(false);
  };

  const normalizeCoordinates = (coords = []) => {
    return coords.map(arr => {
      return { lat: arr[0], lng: arr[1] };
    });
  }

  const getPolygonCenter = (coords, normalize) => {
    if (normalize) coords = normalizeCoordinates(coords);

    let latSum = 0;
    let lngSum = 0;

    coords.forEach(({ lat, lng }) => {
      latSum += lat;
      lngSum += lng;
    });

    return {
      lat: latSum / coords.length,
      lng: lngSum / coords.length,
    };
  };

  const onPolygonComplete = (polygon) => {
    if (isClearingRef.current) {
      polygon.setMap(null);
      setSelectedDrawMode(null);
      isClearingRef.current = false;
      return;
    }
    if (!fromOverspeedPage) return;

    polygonRef.current = polygon;
    const getPathCoords = () => polygon.getPath().getArray().map((latLng) => ({ lat: latLng.lat(), lng: latLng.lng() }));

    const initialPath = getPathCoords();
    setPolygon(initialPath);
    let polygonCenterCoords = getPolygonCenter(initialPath);

    window.google.maps.event.addListener(polygon.getPath(), "set_at", () => {
      fetchCurrentLocation(polygonCenterCoords.lat, polygonCenterCoords.lng);
      let path = getPathCoords();
      setPolygon(path);
    });

    window.google.maps.event.addListener(polygon.getPath(), "insert_at", () => {
      fetchCurrentLocation(polygonCenterCoords.lat, polygonCenterCoords.lng);
      let path = getPathCoords();
      setPolygon(path);
    });

    window.google.maps.event.addListener(polygon.getPath(), "remove_at", () => {
      fetchCurrentLocation(polygonCenterCoords.lat, polygonCenterCoords.lng);
      let path = getPathCoords();
      setPolygon(path);
    });

    fetchCurrentLocation(polygonCenterCoords.lat, polygonCenterCoords.lng);
    setPolygon(initialPath);
    setIsDrawing(false);
  };

  const autocompleteOnLoad = (ref) => {
    autocompleteRef.current = ref;
  }

  const clearGeofence = (allowDrawing) => {
    if (fromOverspeedPage && typeof allowDrawing !== "boolean" && !setMapCircleRef.current && !polygonRef.current && drawingManagerRef.current && isDrawing) {
      isClearingRef.current = true;
      drawingManagerRef.current.setDrawingMode(null);
      setIsDrawing(false);
      setSelectedDrawMode(null);
      return;
    }

    isClearingRef.current = false;

    if (setMapCircleRef.current) {
      setMapCircleRef.current.setMap(null);
      setMapCircleRef.current = null
      setCircle(null);
    }
    if (polygonRef.current) {
      polygonRef.current.setMap(null);
      polygonRef.current = null
      setPolygon(null);
    }

    if (!allowDrawing) setIsDrawing(false);
  }

  const handlePlaceChange = () => {
    const place = autocompleteRef.current.getPlace();
    if (place.geometry) {
      const bounds = new window.google.maps.LatLngBounds();
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();

      bounds.union(place.geometry.viewport);
      mapRef.current.fitBounds(bounds);
      setMarkerLoc({ lat, lng});
    }
  }

  const saveGeofence = async () => {
    if (!enableSaveGeofence) return;

    let geofenceData = { };

    if (isEdit.current) {
      geofenceData = { clientId: filters.client, idx: geofenceId.current, mts: Date.now(), isEnabled: true, typ: GEOFENCE_TRIGGER_TYPE };
      if (geofenceToEdit.title !== geofenceName) {
        geofenceData.title = geofenceName;
      }

      if (geofenceToEdit.region !== geofenceArea) {
        geofenceData.region = geofenceArea;
      }

      if (editedGeofenceRef.current) {
        if (geofenceToEdit.r !== editedGeofenceRef.current.r) {
          geofenceData.r = editedGeofenceRef.current.r;
        }

        if (geofenceToEdit.clat !== editedGeofenceRef.current.clat || geofenceToEdit.clong !== editedGeofenceRef.current.clong) {
          geofenceData.clat = editedGeofenceRef.current.clat;
          geofenceData.clong = editedGeofenceRef.current.clong;
        }
      }

      updateGeofence(geofenceData, (error) => {
        if (error) {
          console.error(error);
          Toast({ isClosable: true, description: error || "Something went wrong", position: "bottom", variant: "subtle", duration: 3000 });
        } else {
          navigate(PATHS.VIEW_GEOFENCES);
        }
      });
    } else {
      geofenceData = { clientId: filters.client, ts: Date.now(), title: geofenceName, desc: geofenceArea, clat: circle.clat, clong: circle.clong, r: circle.r };
      addNewGeofence(geofenceData, (error) => {
        if (error) {
          console.error(error);
          Toast({ isClosable: true, description: error || "Something went wrong", position: "bottom", variant: "subtle", duration: 3000 });
        } else {
          navigate(PATHS.VIEW_GEOFENCES);
        }
      });
    }
  }

  const saveGeofenceAlert = async () => {
    if (!enableSaveGeofence) return;
    let geofenceData = { mts: Date.now() };

    if (isEdit.current) {
      geofenceData.typ = GEOFENCE_TRIGGER_TYPE;
      if (geofenceId.current && Number(geofenceId.current)) geofenceData.idx = Number(geofenceId.current);

      if (geofenceToEdit.title !== geofenceName) {
        geofenceData.title = geofenceName;
      }
      if (geofenceToEdit.region !== geofenceArea) {
        geofenceData.region = geofenceArea;
      }
      if (editedGeofenceRef.current) {
        if (geofenceToEdit.r !== editedGeofenceRef.current.r) {
          geofenceData.r = editedGeofenceRef.current.r;
        }

        if (geofenceToEdit.clat !== editedGeofenceRef.current.clat || geofenceToEdit.clong !== editedGeofenceRef.current.clong) {
          geofenceData.clat = editedGeofenceRef.current.clat;
          geofenceData.clong = editedGeofenceRef.current.clong;
        }
      } else if (editedPolygonVertices.current) {
        geofenceData.vertices = editedPolygonVertices.current;
      }
      if (!isEqual(geofenceVids.current, SelectedVids.current)) {
        geofenceData.vehIdArr = SelectedVids.current;
      }

      if (geofenceData.title || geofenceData.region || geofenceData.r || geofenceData.clat || geofenceData.clong || geofenceData.vehIdArr || geofenceData.vertices) {
        updateAlert(geofenceData, (error) => {
          if (error) {
            console.error("Error Updating New Geofence Alert !" , error);
            Toast({ isClosable: true, description: error || "Something went wrong", position: "bottom", variant: "subtle", duration: 3000 });
          }
          else {
            navigate(`${PATHS.SET_ALERTS}?tab=${1}`)
          }
        });
      }
    }
    else {
      geofenceData = { vehIdArr: SelectedVids.current, title: geofenceName, desc: geofenceArea, clat: circle.clat, clong: circle.clong, r: circle.r, ts: Date.now(), typ:GEOFENCE_TRIGGER_TYPE}
      saveAlert(geofenceData, (error) => {
        if (error) {
          console.error("Error Adding New Geofence Alert !" , error);
          Toast({ isClosable: true, description: error || "Something went wrong", position: "bottom", variant: "subtle", duration: 3000 });
        }
        else {
          navigate(`${PATHS.SET_ALERTS}?tab=${1}`)
        }
      })
    }
  }

  useEffect(() => {
    let isGeofenceEdited = false;
    if (!isEdit.current) {
      if (circle && geofenceName && geofenceArea) {
        isGeofenceEdited = true;
      }
    } else {
      if (geofenceName !== geofenceToEdit.title) {
        isGeofenceEdited = true;
      }

      if (geofenceArea !== geofenceToEdit.region) {
        isGeofenceEdited = true;
      }

      if (editedGeofenceRef.current && (geofenceToEdit.clat !== editedGeofenceRef.current.clat || geofenceToEdit.clong !== editedGeofenceRef.current.clong || geofenceToEdit.r !== editedGeofenceRef.current.r)) {
        isGeofenceEdited = true;
      }

      if (editedPolygonVertices.current) {
        isGeofenceEdited = true;
      }
    }

    setEnableSaveGeoFence(isGeofenceEdited);
  }, [ circle, geofenceName, geofenceArea, geofenceToEdit, updatedPolygon ]);

  const validateGeofence = () => {
    if (!gfNameRef.current) return "Enter Geo fence name";
    if (!gfAreaRef.current) return "Enter Geo fence description";
    if (!polygonRef.current && !setMapCircleRef.current) return "Please draw geofence on map";
    return null;
  };


  useEffect(() => {
    if (emitAlertData) {
      setErrorMsg("");
      const error = validateGeofence();
      if (error) {
        setEmitAlertData(false);
        return setErrorMsg(error);
      }

      let dataToEmit = { title: gfNameRef.current, region: gfAreaRef.current, ts: Date.now(), idx: +geofenceId.current };
      if (polygonRef.current) {
        dataToEmit.polygon = polygonRef.current.getPath().getArray().map((latLng) => ([latLng.lat(), latLng.lng() ]));
        if (editedPolygonVertices.current) dataToEmit.polygon = editedPolygonVertices.current;
      }

      if (setMapCircleRef.current) {
        let circle = { clat: setMapCircleRef.current.center.lat(), clong: setMapCircleRef.current.center.lng(), r: setMapCircleRef.current.radius };
        if (isEdit.current && editedGeofenceRef.current) {
          if (editedGeofenceRef.current.clat) {
            circle.clat = editedGeofenceRef.current.clat;
            circle.clong = editedGeofenceRef.current.clong;
          }

          if (editedGeofenceRef.current.r) circle.r = editedGeofenceRef.current.r;
        }

        dataToEmit.circle = circle;
      }

      global.EE.emitEvent(global.EE.EVENT_TYPES.GEOFENCE_MODAL_DATA, dataToEmit);
    }
  }, [ emitAlertData ]);

  useEffect(() => {
    const from = searchParams.get("fromAlerts");
    if (from) setFromAlerts(true);
    else setFromAlerts(false);
  }, [searchParams, userVehicles])

  const handleCenterChange = () => {
    if (!circleRef.current) return;

    if (geofenceToEdit.clat !== circleRef.current.center.lat() || geofenceToEdit.clong !== circleRef.current.center.lng()) {
      editedGeofenceRef.current = { ...editedGeofenceRef.current, clat: circleRef.current.center.lat(), clong: circleRef.current.center.lng() };
      setEnableSaveGeoFence(true);
    }
  }

  const handleRadiusChange = () => {
    if (!circleRef.current) return;

    if (geofenceToEdit.r !== circleRef.current.radius) {
      editedGeofenceRef.current = { ...editedGeofenceRef.current, r: circleRef.current.radius };
      setEnableSaveGeoFence(true);
    }
  }

  const handleRowSelect = (_, selected) => {
    if (selected && selected.length) {
      SelectedVids.current = selected.map(selection => selection.original.idx);
      if (isEdit.current) setEnableSaveGeoFence(true);
    }
  }

  useEffect(() => {
    if ((!allGeofences || !allGeofences.length) && !fencesFetchedOnce.current) {
      getAlerts(GEOFENCE_TRIGGER_TYPE, (err, data) => {
        fencesFetchedOnce.current = true;

        if(err) console.error("Error fetching geofence alerts", err);
        else setAllGeofences(data);
      });
    }
  }, [ allGeofences ]);

  const handleDrawingModeSelect = (drawingMode) => {
    setIsDrawing(true);
    setSelectedDrawMode(drawingMode);
    clearGeofence(true);
  }

  const handlePolygonLoad = (ref) => {
    polygonRef.current = ref;
    const path = ref.getPath();

    const updatePolygonVertices = () => {
      const updatedPath = path.getArray().map((latLng) => [latLng.lat(), latLng.lng()]);
      editedPolygonVertices.current = updatedPath;
      setUpdatedPolygon(updatedPath);
    };

    window.google.maps.event.addListener(path, "set_at", updatePolygonVertices);
    window.google.maps.event.addListener(path, "insert_at", updatePolygonVertices);
    window.google.maps.event.addListener(path, "remove_at", updatePolygonVertices);
  }

  return (
    <>
      {isLoaded ? <div className="panel-main add-geofence">
        <header>
          <Breadcrumb paths={fromAlerts ? fromAlertBreadcrumbPaths : breadcrumbPaths} />
          { !fromAlerts ? <ClientPicker /> : null }
        </header>
        <div className="geofence-map">
          <GoogleMap
            mapContainerClassName="map-container"
            center={mapCenter}
            zoom={4}
            onLoad={onLoad}
            options={{
              fullscreenControl: false,
              mapTypeControl: false,
              scaleControl: true,
              streetViewControl: false,
              maxZoom: 18,
              gestureHandling: "cooperative",
            }}
          >
            <div className="map-drawing-buttons">
              <div>
                <Checkbox onChange={(e) => setShowExistingGeofences(e.target.checked)} checked={showExistingGeofences} className="view-existing-geofences">
                  View Existing Geofences
                </Checkbox>
              </div>
              {!editIdx && <button onClick={clearGeofence} className="cancel-drawing">
                Clear
              </button>}
              {!isEdit.current && <button onClick={() => handleDrawingModeSelect(window.google.maps.drawing.OverlayType.CIRCLE)} className={`toggle-drawing circle-btn ${isDrawing && selectedDrawMode === "circle" ? "disable-drawing" : ""}`}>
                <GeoFenceIcon />
                Circle
              </button>}
              {fromOverspeedPage && !isEdit.current && <button onClick={() => handleDrawingModeSelect(window.google.maps.drawing.OverlayType.POLYGON)} className={`toggle-drawing polygon-btn ${isDrawing && selectedDrawMode === "polygon" ? "disable-drawing" : ""}`}>
                <PolygonIcon />
                Polygon
              </button>}
            </div>

            {(isDrawing && !isEdit.current) ? <DrawingManager
              onLoad={(ref) => drawingManagerRef.current = ref}
              drawingMode={selectedDrawMode}
              options={{
                drawingControlOptions: {
                  drawingModes: [ window.google.maps.drawing.OverlayType.CIRCLE, window.google.maps.drawing.OverlayType.POLYGON ]
                },
                drawingControl: false,
                circleOptions: {
                  fillColor: "#00A8E270",
                  strokeWeight: 2,
                  strokeColor: "#00A8E2",
                  strokeOpacity: 0.8,
                  clickable: false,
                  editable: true,
                  zIndex: 1,
                },
                polygonOptions: {
                  fillColor: "#00A8E270",
                  strokeColor: "#00A8E2",
                  strokeOpacity: 0.8,
                  strokeWeight: 2,
                  clickable: false,
                  editable: true,
                  zIndex: 1,
                },
              }}
              onCircleComplete={onCircleComplete}
              onPolygonComplete={onPolygonComplete}
            /> : null}

            { (markerLoc.lat && markerLoc.lng) ? <Marker position={markerLoc} /> : null }

            <Autocomplete
              onLoad={autocompleteOnLoad}
              onPlaceChanged={handlePlaceChange}
            >
              <div className="geofence-search-input">
                <SearchIcon />
                <input
                  type="text"
                  placeholder="Search Location"
                />
              </div>
            </Autocomplete>
            {geofenceToEdit.idx ? (
              geofenceToEdit.vertexes && geofenceToEdit.vertexes.length ? (
                <Polygon
                  onLoad={(ref) => handlePolygonLoad(ref)}
                  path={geofenceToEdit.vertexes}
                  editable={true}
                  clickable={false}
                  options={{
                    fillColor: "#00A8E270",
                    strokeWeight: 2,
                    strokeColor: "#00A8E2",
                    strokeOpacity: 0.8,
                  }}
                  zIndex={1}
                />
              ) : (
                <Circle
                  onLoad={(ref) => (circleRef.current = ref)}
                  radius={editedGeofenceRef.current?.r || geofenceToEdit.r}
                  center={{
                    lat: editedGeofenceRef.current?.clat || geofenceToEdit.clat,
                    lng: editedGeofenceRef.current?.clong || geofenceToEdit.clong,
                  }}
                  editable={true}
                  clickable={false}
                  options={{
                    fillColor: "#00A8E270",
                    strokeWeight: 2,
                    strokeColor: "#00A8E2",
                    strokeOpacity: 0.8,
                  }}
                  zIndex={1}
                  onCenterChanged={handleCenterChange}
                  onRadiusChanged={handleRadiusChange}
                />
              )
            ) : null}

            { (showExistingGeofences && allGeofences && allGeofences.length) ?
              allGeofences.map(geofence => (
                <div key={geofence.idx} >
                  {!(geofence.vertices && geofence.vertices.length) ? <Circle
                    key={geofence.idx}
                    radius={geofence.r}
                    center={{ lat: geofence.clat, lng: geofence.clong }}
                    editable={false}
                    clickable={false}
                    options={{ fillColor: "#00A8E270", strokeWeight: 2, strokeColor: "#00A8E2", strokeOpacity: 0.8, }}
                    zIndex={1}
                    onClick={() => setInfoWindowDetails(geofence)}
                  />
                  :
                  <Polygon
                    key={geofence.idx}
                    path={normalizeCoordinates(geofence.vertices)}
                    editable={false}
                    clickable={false}
                    options={{
                      fillColor: "#007AFF33",
                      strokeWeight: 2,
                      strokeColor: "#007AFF",
                      strokeOpacity: 0.8,
                    }}
                    zIndex={1}
                  />}
                </div>
              ))
              :
              null
            }

            {(showExistingGeofences && infoWindowDetails && infoWindowDetails.idx) ? <InfoWindow
              position={{ lat: infoWindowDetails.clat, lng: infoWindowDetails.clong }}
              options={{ pixelOffset: new window.google.maps.Size(0, -20) }}
              onCloseClick={() => setInfoWindowDetails({})}
            >
              <div className="info-box">
                <label>
                  Title:
                  <p>{infoWindowDetails.title || infoWindowDetails.region || infoWindowDetails.desc || infoWindowDetails.idx || "geofence"}</p>
                </label>
              </div>
            </InfoWindow> : null}
          </GoogleMap>
        </div>

        <div className="geofence-inputs">
          <Input value={geofenceName} onChange={(e) => {setGeofenceName(e.target.value); gfNameRef.current = e.target.value; setErrorMsg("")}} placeholder="Enter Geo-fence name" className={`geofence-name ${fromOverspeedPage && errorMsg ? "hightlight-border" : ""}`} />
          <Input value={geofenceArea} onChange={(e) => {setGeofenceArea(e.target.value); gfAreaRef.current = e.target.value; setErrorMsg("")}} placeholder={fromOverspeedPage ? "Geo fence location" : "Geo fence description"} />

          {
            !fromAlerts
          ? <Button className={`save-geofence ${enableSaveGeofence ? "" : "disbaled-geofence-button"}`} disabled={enableSaveGeofence} onClick={saveGeofence}>
            Save
          </Button> : null
          }
        </div>
        { fromOverspeedPage && errorMsg ? <p className="os-gf-err-msg">{errorMsg}</p> : null}
        { !fromAlerts ? <p className="geofence-note">This geo-fence will be applied to all the vehicles leased to zomato</p> : null}
        { fromAlerts ? (
            <AlertsVehiclesTable key={triggerRender} headers={ALERT_VEHICLE_TABLE_HEADERS} className={"add-geo-table-cnt"} handleRowSelect={handleRowSelect} selectedRows={SelectedVids.current} />
          ) : null}
        {
          fromAlerts ?
            <div className="btn-container">
              <Button className={`save-geofence-alert ${enableSaveGeofence ? "" : "disbaled-geofence-button"}`} disabled={enableSaveGeofence} onClick={saveGeofenceAlert}>
               Save Geofence Alert
              </Button>
            </div>
          : null
        }
      </div> : null}
    </>
  )
}

export default AddGeofence
